import { TExperimentsState } from '../../types/experiments';

const defaultState: TExperimentsState = {};

export function experimentsReducer(state: TExperimentsState = defaultState): TExperimentsState {
  return state;
}
